import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CTAButton } from '../ui/CTAButton';
import { AlertTriangleIcon, ClockIcon, UsersIcon } from 'lucide-react';
export function UrgencySection() {
  return <SectionWrapper id="urgencia" withGlow glowPosition="top" data-id="element-419">
      <div className="max-w-3xl mx-auto text-center" data-id="element-420">
        <div className="inline-flex items-center gap-2 px-4 py-2 mb-8 border border-red-500/30 rounded-full bg-red-500/5" data-id="element-421">
          <AlertTriangleIcon className="w-4 h-4 text-red-400" aria-hidden="true" data-id="element-422" />
          <span className="text-red-400 text-sm font-medium tracking-wider uppercase" data-id="element-423">
            Aviso importante
          </span>
        </div>

        <h2 className="font-display text-3xl md:text-4xl font-bold text-[#e8e6e1] mb-8 leading-tight" data-id="element-424">
          Este protocolo{' '}
          <span className="text-gold-gradient" data-id="element-425">no es para todos</span>
        </h2>

        <div className="space-y-6 text-left mb-12" data-id="element-426">
          <div className="flex items-start gap-4 p-5 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-427">
            <ClockIcon className="w-5 h-5 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-428" />
            <p className="text-[#9a9aab] leading-relaxed" data-id="element-429">
              <span className="text-[#e8e6e1] font-medium" data-id="element-430">
                Este precio no es permanente.
              </span>{' '}
              El valor real del protocolo completo es $297 USD. La oferta de $27
              está disponible únicamente durante este periodo de lanzamiento y
              puede cerrarse sin previo aviso.
            </p>
          </div>

          <div className="flex items-start gap-4 p-5 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-431">
            <UsersIcon className="w-5 h-5 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-432" />
            <p className="text-[#9a9aab] leading-relaxed" data-id="element-433">
              <span className="text-[#e8e6e1] font-medium" data-id="element-434">
                No distribuimos este protocolo masivamente.
              </span>{' '}
              Mantenemos un acceso controlado para asegurar que cada persona que
              entre realmente se comprometa con su transformación. Esto no es
              entretenimiento.
            </p>
          </div>

          <div className="flex items-start gap-4 p-5 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-435">
            <AlertTriangleIcon className="w-5 h-5 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-436" />
            <p className="text-[#9a9aab] leading-relaxed" data-id="element-437">
              <span className="text-[#e8e6e1] font-medium" data-id="element-438">
                Solo para personas serias.
              </span>{' '}
              Si buscas otra "solución mágica" que no requiera compromiso, este
              protocolo no es para ti. Pero si estás listo para hacer el trabajo
              real de reprogramar tu identidad,
              <span className="text-[#c9a84c]" data-id="element-439"> este es tu momento.</span>
            </p>
          </div>
        </div>

        <CTAButton size="large" data-id="element-440">Asegurar mi acceso ahora — $27</CTAButton>

        <p className="text-[#6b6b7b] text-sm mt-4" data-id="element-441">
          Acceso inmediato tras el pago · Sin riesgo
        </p>
      </div>
    </SectionWrapper>;
}